import {IconAddOutline, MediaObject, Text} from '@treatwell/ui';
import styles from './AddServiceLink.module.css';
import {trackAddService} from '../../utils/gtmTracking';
type Props = {
  url: string;
  text: string;
};

export const AddServiceLink = ({url, text}: Props) => {
  return (
    <a
      href={url}
      className={styles.link}
      data-cy="AddServiceLink"
      onClick={async (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        await trackAddService();
        window.location.href = url;
      }}
    >
      <MediaObject align="center" space="2md">
        <IconAddOutline size={24} />
        <Text type="body">{text}</Text>
      </MediaObject>
    </a>
  );
};
